const firstListItem = document.querySelector('.property-information-card .list-group .list-group-item');
const twoColMaxWidth = 1009;

if (window.innerWidth > twoColMaxWidth) {
  firstListItem.className += ' js-default-open';
}
